import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/lib/api.ts'
import type {
  ContractCustomField,
  CreateCustomFieldInput,
  UpdateCustomFieldInput,
} from '../types.ts'

export function useContractCustomFields() {
  return useQuery<ContractCustomField[]>({
    queryKey: ['contract-custom-fields', 'list'],
    queryFn: () => apiClient.get('/contracts/custom-fields').then((r) => r.data),
  })
}

export function useCreateContractCustomField() {
  const qc = useQueryClient()
  return useMutation<ContractCustomField, Error, CreateCustomFieldInput>({
    mutationFn: (input) => apiClient.post('/contracts/custom-fields', input).then((r) => r.data),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['contract-custom-fields'] })
      void qc.invalidateQueries({ queryKey: ['contracts', 'detail'] })
    },
  })
}

export function useUpdateContractCustomField() {
  const qc = useQueryClient()
  return useMutation<ContractCustomField, Error, { id: string; patch: UpdateCustomFieldInput }>({
    mutationFn: ({ id, patch }) =>
      apiClient.patch(`/contracts/custom-fields/${id}`, patch).then((r) => r.data),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['contract-custom-fields'] })
      void qc.invalidateQueries({ queryKey: ['contracts', 'detail'] })
    },
  })
}

export function useDeleteContractCustomField() {
  const qc = useQueryClient()
  return useMutation<void, Error, string>({
    mutationFn: (id) => apiClient.delete(`/contracts/custom-fields/${id}`).then(() => undefined),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['contract-custom-fields'] })
      void qc.invalidateQueries({ queryKey: ['contracts', 'detail'] })
    },
  })
}
